import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../Images/logo.png';
import poster from '../../Images/poster.png';
import './Auth.css';
import API_URL from "../../api/ExamCalendarApi";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    mobileOrEmail: '',
    password: ''
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [loginSuccess, setLoginSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${API_URL}/user/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          mobileOrEmail: formData.mobileOrEmail,
          password: formData.password
        })
      });

      const data = await response.json();

      if (response.ok) {
        if (data.isAdmin) { // Check if the user is an admin
          setErrorMessage('');
          setLoginSuccess(true); // Set local state loginSuccess
          // Store token in localStorage and trigger login in parent component
          localStorage.setItem('authToken', data.token); // Store token
          onLogin(data.token); // Trigger login in parent
        } else {
          setErrorMessage('You are not an admin.');
        }
      } else {
        setErrorMessage(data.error || 'Invalid credentials.');
      }
    } catch (error) {
      setErrorMessage('An error occurred. Please try again later.');
      console.error('Error during login:', error);
    }
  };

  // Effect to navigate when loginSuccess is true
  useEffect(() => {
    if (loginSuccess) {
      navigate('/'); // Redirect to homepage on successful login
    }
  }, [loginSuccess, navigate]);

  // Prevent re-navigating to login page if already logged in
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/'); // Redirect to homepage if token is already present
    }
  }, [navigate]);

  return (
    <div className="admin-auth-container">
      <div className="admin-auth-poster-image">
        <a href='https://www.youtube.com/@shyaminstitute-kakinada'>
          <img src={poster} alt="Poster" />
        </a>
      </div>

      <div className="admin-auth-form-container">
        <div className="admin-auth-form">
          <img src={logo} alt="Logo" className="admin-auth-logo" />
          <h2 className='admin-auth-title'>Login To Your Account</h2>

          {errorMessage && <div className="admin-auth-error-message">{errorMessage}</div>}

          <form onSubmit={handleSubmit}>
            <div className="admin-auth-form-group">
              <input
              className='admin-auth-input'
                type="text"
                name="mobileOrEmail"
                placeholder="mobile Or Email"
                value={formData.mobileOrEmail}
                onChange={handleChange}
                required
              />
            </div>

            <div className="admin-auth-form-group">
              <input
              className='admin-auth-input'
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="admin-auth-submit-btn">
              Login
            </button>
          </form>

          {/* <p>
            Don't have an account? <a href="/signup">Sign Up</a>
          </p> */}

          {/* <div className='forgot-password'>
            <a href="#hi">Forgot Password</a>
          </div> */}

        </div>
      </div>

    </div>
  );
};

export default Login;
